import * as Yup from "yup";

export const updateStoreSchema = Yup.object().shape({
  businessname: Yup.string().required("Business name is required"),
  businesstype: Yup.string().required("Business type is required"),
  tinnumber: Yup.string().optional(),
  phonenumber: Yup.string().required("Phone number is required"),
  location: Yup.string().required("Location is required"),
});
